export default "__VITE_ASSET__CtvbNS86__"